export default __webpack_public_path__ + "static/media/DaciaBlock-Bold.dd121ad2.eot";